
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "../assets/css/GroupLoanScheme.css";
// const API_URL = process.env.REACT_APP_API_URL;

// const GroupLoanScheme = () => {
//   const [formData, setFormData] = useState({
//     schemeName: "",
//     centreName: "",
//     principal: "",
//     tenure: "",
//     roi: "",
//     recoveryFrequency: "monthly",
//     collectorName: "",
//     loanRoiType: "flat", // flat / reducing
//     loanDisbursalMode: "cash", // cash / bank / other
//     loanAppliedDate: new Date().toISOString().split("T")[0], // default today
//     collectionLandmark: "",
//     loanPurpose: "",
//     generateEmi: true,
//     createdBy: localStorage.getItem("userId") || 1,
//   });
// const [customers, setCustomers] = useState([]);

//   const [clients, setClients] = useState([{ memberId: "", loanAmount: "" }]);
//   const [loading, setLoading] = useState(false);
//   const [groups, setGroups] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState("");
//     const [profile, setProfile] = useState(null);


// // const [clients, setClients] = useState([{ userId: "", loanAmount: "" }]);


// useEffect(() => {
//   const fetchCustomers = async () => {
//     try {
//       const res = await axios.get(`${API_URL}/customers?branchId=${localStorage.getItem("userId")}`, {
//       });
//       if (Array.isArray(res.data.data)) {
//         setCustomers(res.data.data);
//       } else {
//         setCustomers([]);
//       }
//     } catch (err) {
//       console.error("❌ Error fetching customers:", err);
//       setCustomers([]);
//     }
//   };
//   fetchCustomers();
// }, []);



//   useEffect(() => {
//     const fetchGroups = async () => {
//       try {
//         const res = await axios.get(`https://payyug.in/api/get-group?branch_id=${localStorage.getItem("userId")}`);
//         if (Array.isArray(res.data.data)) {
//           setGroups(res.data.data);
//         } else {
//           setGroups([]);
//         }
//       } catch (err) {
//         console.error("❌ Error fetching groups:", err);
//         setGroups([]);
//       }
//     };
//     fetchGroups();
//   }, []);
// // fetch profile
// useEffect(() => {
//   const fetchProfile = async () => {
//     try {
//       const res = await axios.get(
//         `https://payyug.in/api/get-profile/${localStorage.getItem("userId")}`,
//         { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
//       );
//       setProfile(res.data); // ✅ directly use
//     } catch (err) {
//       console.error("❌ Error fetching profile:", err);
//     }
//   };
//   fetchProfile();
// }, []);


//   // handle field change
//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   // dynamic members
//   const handleClientChange = (index, e) => {
//     const updated = [...clients];
//     updated[index][e.target.name] = e.target.value;
//     setClients(updated);
//   };

//   const addClientRow = () => {
//     setClients([...clients, { memberId: "", loanAmount: "" }]);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedGroup) {
//       alert("⚠️ Please select a group before applying");
//       return;
//     }
//     if (!profile) {
//     alert("⚠️ Profile not loaded yet");
//     return;
//   }
//     setLoading(true);
//     const payload = {
//   groupId: Number(selectedGroup),
//   superAdminId: Number(profile.superAdminId),
//   branchId: Number(localStorage.getItem("userId")), // ✅ force number
//   centreId: 101,
//   schemeName: formData.schemeName.trim(),
//   centreName: formData.centreName.trim(),
//   principal: Number(formData.principal),
//   tenure: Number(formData.tenure),
//   roi: Number(formData.roi),
//   recoveryFrequency: formData.recoveryFrequency || "monthly",
//   collectorName: formData.collectorName.trim(),
//   loanRoiType: formData.loanRoiType || "reducing",   // ✅ never empty
//   loanDisbursalMode: formData.loanDisbursalMode || "cash",
//   loanAppliedDate: formData.loanAppliedDate,
//   collectionLandmark: formData.collectionLandmark,
//   loanPurpose: formData.loanPurpose,
//   generateEmi: formData.generateEmi,
//   createdBy: Number(localStorage.getItem("userId")) || 1,
//   members: clients.map((c) => ({
//     memberId: c.userId,
//     loanAmount: Number(c.loanAmount),
//   })),
// };


//     try {
//       const res = await axios.post(
//         `https://payyug.in/api/group-loan/${selectedGroup}/applynew`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         }
//       );
//       alert("✅ Group Loan Applied Successfully!");
//       console.log("API Response:", res.data);

//       // reset form
//       setFormData({
//         schemeName: "",
//         centreName: "",
//         principal: "",
//         tenure: "",
//         roi: "",
//         recoveryFrequency: "monthly",
//         collectorName: "",
//         loanRoiType: "flat",
//         loanDisbursalMode: "cash",
//         loanAppliedDate: new Date().toISOString().split("T")[0],
//         collectionLandmark: "",
//         loanPurpose: "",
//         generateEmi: true,
//         createdBy: localStorage.getItem("userId") || 1,
//       });
//       setClients([{ memberId: "", loanAmount: "" }]);
//       setSelectedGroup("");
//     } catch (error) {
//       console.error("❌ Error applying group loan:", error);
//       alert(error.response?.data?.message || "Failed to apply loan");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="group-loan-container">
//       <h2 className="form-title">Apply  Loan </h2>

//       <form onSubmit={handleSubmit}>
//         {/* === Group Selector === */}
//         <div className="form-group">
//           <label>Select Group</label>
//           <select
//             value={selectedGroup}
//             onChange={(e) => setSelectedGroup(e.target.value)}
//             required
//           >
//             <option value="">-- Select Group --</option>
//             {groups.map((g) => (
//               <option key={g.id} value={g.id}>
//                 {g.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* === Loan Details === */}
//         <div className="form-grid-two-column">
//           <div className="form-group">
//             <label>Scheme Name</label>
//             <input
//               type="text"
//               name="schemeName"
//               value={formData.schemeName}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Centre Name</label>
//             <input
//               type="text"
//               name="centreName"
//               value={formData.centreName}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Principal Amount</label>
//             <input
//               type="number"
//               name="principal"
//               value={formData.principal}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Tenure (Months)</label>
//             <input
//               type="number"
//               name="tenure"
//               value={formData.tenure}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>ROI Annual (%)</label>
//             <input
//               type="number"
//               name="roi"
//               value={formData.roi}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Recovery Frequency</label>
//             <select
//               name="recoveryFrequency"
//               value={formData.recoveryFrequency}
//               onChange={handleChange}
//             >
//               <option value="monthly">Monthly</option>
//               <option value="quarterly">Quarterly</option>
//               <option value="yearly">Yearly</option>
//               <option value="weekly">Weekly</option>
//               <option value="biweekly">Bi-Weekly</option>
//               <option value="halfyearly">Half-Yearly</option>
//               <option value="delay">Delay</option>
//             </select>
//           </div>

//           <div className="form-group">
//             <label>Collector Name</label>
//             <input
//               type="text"
//               name="collectorName"
//               value={formData.collectorName}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>ROI Type</label>
//             <select
//               name="loanRoiType"
//               value={formData.loanRoiType}
//               onChange={handleChange}
//             >
//               <option value="flat">Flat</option>
//               <option value="reducing">Reducing</option>
//             </select>
//           </div>

//           <div className="form-group">
//             <label>Disbursal Mode</label>
//             <select
//               name="loanDisbursalMode"
//               value={formData.loanDisbursalMode}
//               onChange={handleChange}
//             >
//               <option value="cash">Cash</option>
//               <option value="bank">Bank</option>
//               <option value="other">Other</option>
//             </select>
//           </div>

//           <div className="form-group">
//             <label>Applied Date</label>
//             <input
//               type="date"
//               name="loanAppliedDate"
//               value={formData.loanAppliedDate}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Collection Landmark</label>
//             <input
//               type="text"
//               name="collectionLandmark"
//               value={formData.collectionLandmark}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="form-group">
//             <label>Loan Purpose</label>
//             <input
//               type="text"
//               name="loanPurpose"
//               value={formData.loanPurpose}
//               onChange={handleChange}
//             />
//           </div>
//         </div>

//         {/* === Members Section === */}
//         <h3 className="section-title">Group Members</h3>
//         {/* {clients.map((client, index) => (
//           <div className="form-row" key={index}>
//             <input
//               type="number"
//               name="memberId"
//               placeholder="Member ID"
//               value={client.memberId}
//               onChange={(e) => handleClientChange(index, e)}
//               required
//             />
//             <input
//               type="number"
//               name="loanAmount"
//               placeholder="Loan Amount"
//               value={client.loanAmount}
//               onChange={(e) => handleClientChange(index, e)}
//               required
//             />
//           </div>
//         ))} */}
//         {clients.map((client, index) => (
//   <div className="form-row" key={index}>
//     <select
//       name="userId"
//       value={client.userId}
//       onChange={(e) => handleClientChange(index, e)}
//       required
//     >
//       <option value="">-- Select Customer --</option>
//       {customers.map((cust) => (
//         <option key={cust.userId} value={cust.userId}>
//           {cust.userId} - {cust.fullName}
//         </option>
//       ))}
//     </select>

//     <input
//       type="number"
//       name="loanAmount"
//       placeholder="Loan Amount"
//       value={client.loanAmount}
//       onChange={(e) => handleClientChange(index, e)}
//       required
//     />
//   </div>
// ))}

//         <button type="button" onClick={addClientRow} className="btn add">
//           ➕ Add Member
//         </button>

//         <div className="form-actions">
//           <button type="submit" className="btn submit" disabled={loading}>
//             {loading ? "Submitting..." : "🚀 Apply Loan"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default GroupLoanScheme;



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "../assets/css/GroupLoanScheme.css";
// const API_URL = process.env.REACT_APP_API_URL;

// const GroupLoanScheme = () => {
//   const [formData, setFormData] = useState({
//     schemeName: "",
//     centreName: "",
//     principal: "",
//     tenure: "",
//     roi: "",
//     recoveryFrequency: "monthly",
//     collectorName: "",
//     loanRoiType: "flat", // flat / reducing
//     loanDisbursalMode: "cash", // cash / bank / other
//     loanAppliedDate: new Date().toISOString().split("T")[0], // default today
//     collectionLandmark: "",
//     loanPurpose: "",
//     generateEmi: true,
//     createdBy: localStorage.getItem("userId") || 1,
//   });

//   const [customers, setCustomers] = useState([]);
//   const [clients, setClients] = useState([{ userId: "", loanAmount: "", isLeader: false }]);
//   const [loading, setLoading] = useState(false);
//   const [groups, setGroups] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState("");
//   const [profile, setProfile] = useState(null);

//   // fetch customers
//   useEffect(() => {
//     const fetchCustomers = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/customers?branchId=${localStorage.getItem("userId")}`);
//         if (Array.isArray(res.data.data)) {
//           setCustomers(res.data.data);
//         } else {
//           setCustomers([]);
//         }
//       } catch (err) {
//         console.error("❌ Error fetching customers:", err);
//         setCustomers([]);
//       }
//     };
//     fetchCustomers();
//   }, []);

//   // fetch groups
//   useEffect(() => {
//     const fetchGroups = async () => {
//       try {
//         const res = await axios.get(`https://payyug.in/api/get-group?branch_id=${localStorage.getItem("userId")}`);
//         if (Array.isArray(res.data.data)) {
//           setGroups(res.data.data);
//         } else {
//           setGroups([]);
//         }
//       } catch (err) {
//         console.error("❌ Error fetching groups:", err);
//         setGroups([]);
//       }
//     };
//     fetchGroups();
//   }, []);

//   // fetch profile
//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const res = await axios.get(
//           `https://payyug.in/api/get-profile/${localStorage.getItem("userId")}`,
//           { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
//         );
//         setProfile(res.data);
//       } catch (err) {
//         console.error("❌ Error fetching profile:", err);
//       }
//     };
//     fetchProfile();
//   }, []);

//   // handle field change
//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   // handle client change
//   const handleClientChange = (index, e) => {
//     const updated = [...clients];
//     const { name, value, type, checked } = e.target;
//     updated[index][name] = type === "checkbox" ? checked : value;
//     setClients(updated);
//   };

//   // add new client row
//   const addClientRow = () => {
//     setClients([...clients, { memberId: "", loanAmount: "", isLeader: false }]);
//   };

//   // handle submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedGroup) {
//       alert("⚠️ Please select a group before applying");
//       return;
//     }
//     if (!profile) {
//       alert("⚠️ Profile not loaded yet");
//       return;
//     }
//     setLoading(true);

//     const payload = {
//       groupId: Number(selectedGroup),
//       superAdminId: Number(profile.superAdminId),
//       branchId: Number(localStorage.getItem("userId")),
//       centreId: 101,
//       schemeName: formData.schemeName.trim(),
//       centreName: formData.centreName.trim(),
//       principal: Number(formData.principal),
//       tenure: Number(formData.tenure),
//       roi: Number(formData.roi),
//       recoveryFrequency: formData.recoveryFrequency || "monthly",
//       collectorName: formData.collectorName.trim(),
//       loanRoiType: formData.loanRoiType || "reducing",
//       loanDisbursalMode: formData.loanDisbursalMode || "cash",
//       loanAppliedDate: formData.loanAppliedDate,
//       collectionLandmark: formData.collectionLandmark,
//       loanPurpose: formData.loanPurpose,
//       generateEmi: formData.generateEmi,
//       createdBy: Number(localStorage.getItem("userId")) || 1,
//       members: clients.map((c) => ({
//         memberId: c.userId,
//         loanAmount: Number(c.loanAmount),
//         isLeader: c.isLeader || false,
//       })),
//     };

//     try {
//       const res = await axios.post(
//         // `https://payyug.in/api/group-loan/${selectedGroup}/applynew`,
//         `https://payyug.in/api/group-loan/apply-loan-group`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         }
//       );
//       alert("✅ Group Loan Applied Successfully!");
//       console.log("API Response:", res.data);

//       // reset form
//       setFormData({
//         schemeName: "",
//         centreName: "",
//         principal: "",
//         tenure: "",
//         roi: "",
//         recoveryFrequency: "monthly",
//         collectorName: "",
//         loanRoiType: "flat",
//         loanDisbursalMode: "cash",
//         loanAppliedDate: new Date().toISOString().split("T")[0],
//         collectionLandmark: "",
//         loanPurpose: "",
//         generateEmi: true,
//         createdBy: localStorage.getItem("userId") || 1,
//       });
//       setClients([{ memberId: "", loanAmount: "", isLeader: false }]);
//       setSelectedGroup("");
//     } catch (error) {
//       console.error("❌ Error applying group loan:", error);
//       alert(error.response?.data?.message || "Failed to apply loan");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="group-loan-container">
//       <h2 className="form-title">Apply Loan</h2>

//       <form onSubmit={handleSubmit}>
//         {/* === Group Selector === */}
//         <div className="form-group">
//           <label>Select Group</label>
//           <select
//             value={selectedGroup}
//             onChange={(e) => setSelectedGroup(e.target.value)}
//             required
//           >
//             <option value="">-- Select Group --</option>
//             {groups.map((g) => (
//               <option key={g.id} value={g.id}>
//                 {g.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* === Loan Details === */}
//         <div className="form-grid-two-column">
//           <div className="form-group">
//             <label>Scheme Name</label>
//             <input
//               type="text"
//               name="schemeName"
//               value={formData.schemeName}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Centre Name</label>
//             <input
//               type="text"
//               name="centreName"
//               value={formData.centreName}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Principal Amount</label>
//             <input
//               type="number"
//               name="principal"
//               value={formData.principal}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Tenure (Months)</label>
//             <input
//               type="number"
//               name="tenure"
//               value={formData.tenure}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>ROI Annual (%)</label>
//             <input
//               type="number"
//               name="roi"
//               value={formData.roi}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Recovery Frequency</label>
//             <select
//               name="recoveryFrequency"
//               value={formData.recoveryFrequency}
//               onChange={handleChange}
//             >
//               <option value="monthly">Monthly</option>
//               <option value="quarterly">Quarterly</option>
//               <option value="yearly">Yearly</option>
//               <option value="weekly">Weekly</option>
//               <option value="biweekly">Bi-Weekly</option>
//               <option value="halfyearly">Half-Yearly</option>
//               <option value="delay">Delay</option>
//             </select>
//           </div>

//           <div className="form-group">
//             <label>Collector Name</label>
//             <input
//               type="text"
//               name="collectorName"
//               value={formData.collectorName}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>ROI Type</label>
//             <select
//               name="loanRoiType"
//               value={formData.loanRoiType}
//               onChange={handleChange}
//             >
//               <option value="flat">Flat</option>
//               <option value="reducing">Reducing</option>
//             </select>
//           </div>

//           <div className="form-group">
//             <label>Disbursal Mode</label>
//             <select
//               name="loanDisbursalMode"
//               value={formData.loanDisbursalMode}
//               onChange={handleChange}
//             >
//               <option value="cash">Cash</option>
//               <option value="bank">Bank</option>
//               <option value="other">Other</option>
//             </select>
//           </div>

//           <div className="form-group">
//             <label>Applied Date</label>
//             <input
//               type="date"
//               name="loanAppliedDate"
//               value={formData.loanAppliedDate}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Collection Landmark</label>
//             <input
//               type="text"
//               name="collectionLandmark"
//               value={formData.collectionLandmark}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="form-group">
//             <label>Loan Purpose</label>
//             <input
//               type="text"
//               name="loanPurpose"
//               value={formData.loanPurpose}
//               onChange={handleChange}
//             />
//           </div>
//         </div>

//         {/* === Members Section === */}
//         <h3 className="section-title">Group Members</h3>
//         {clients.map((client, index) => (
//           <div className="form-row" key={index}>
//             <select
//               name="userId"
//               value={client.userId}
//               onChange={(e) => handleClientChange(index, e)}
//               required
//             >
//               <option value="">-- Select Customer --</option>
//               {customers.map((cust) => (
//                 <option key={cust.userId} value={cust.userId}>
//                   {cust.userId} - {cust.fullName}
//                 </option>
//               ))}
//             </select>

//             <input
//               type="number"
//               name="loanAmount"
//               placeholder="Loan Amount"
//               value={client.loanAmount}
//               onChange={(e) => handleClientChange(index, e)}
//               required
//             />

//             <label>
//               <input
//                 type="checkbox"
//                 name="isLeader"
//                 checked={client.isLeader || false}
//                 onChange={(e) => handleClientChange(index, e)}
//               />
//               Leader
//             </label>
//           </div>
//         ))}

//         <button type="button" onClick={addClientRow} className="btn add">
//           ➕ Add Member
//         </button>

//         <div className="form-actions">
//           <button type="submit" className="btn submit" disabled={loading}>
//             {loading ? "Submitting..." : "🚀 Apply Loan"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default GroupLoanScheme;




import React, { useState, useEffect } from "react";
import axios from "axios";
import "../assets/css/GroupLoanScheme.css";
import { toast } from "react-toastify";
const API_URL = process.env.REACT_APP_API_URL;

const GroupLoanScheme = () => {
  const [formData, setFormData] = useState({
    schemeName: "",
    centreName: "",
    principal: "",
    tenure: "",
    roi: "",
    recoveryFrequency: "monthly",
    collectorName: "",
    loanRoiType: "flat",
    loanDisbursalMode: "cash",
    loanAppliedDate: new Date().toISOString().split("T")[0],
    collectionLandmark: "",
    loanPurpose: "",
    generateEmi: false, // default false
    createdBy: localStorage.getItem("userId") || 1,
  });

  const [customers, setCustomers] = useState([]);
  const [clients, setClients] = useState([{ userId: "", loanAmount: "", isLeader: false }]);
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [profile, setProfile] = useState(null);

  // fetch customers
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await axios.get(`${API_URL}/customers?branchId=${localStorage.getItem("userId")}`);
        setCustomers(Array.isArray(res.data.data) ? res.data.data : []);
      } catch (err) {
        console.error("❌ Error fetching customers:", err);
        setCustomers([]);
      }
    };
    fetchCustomers();
  }, []);

  // fetch groups
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await axios.get(`https://payyug.in/api/get-group?branch_id=${localStorage.getItem("userId")}`);
        setGroups(Array.isArray(res.data.data) ? res.data.data : []);
      } catch (err) {
        console.error("❌ Error fetching groups:", err);
        setGroups([]);
      }
    };
    fetchGroups();
  }, []);

  // fetch profile
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(
          `https://payyug.in/api/get-profile/${localStorage.getItem("userId")}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
        );
        setProfile(res.data);
      } catch (err) {
        console.error("❌ Error fetching profile:", err);
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleClientChange = (index, e) => {
    const updated = [...clients];
    const { name, value, type, checked } = e.target;
    updated[index][name] = type === "checkbox" ? checked : value;
    setClients(updated);
  };

  const addClientRow = () => {
    setClients([...clients, { userId: "", loanAmount: "", isLeader: false }]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedGroup) return toast.warn("⚠️ Please select a group before applying");
    if (!profile) return toast.warn("⚠️ Profile not loaded yet");

    setLoading(true);

    const payload = {
      groupId: Number(selectedGroup),
      superAdminId: Number(profile.superAdminId),
      branchId: Number(localStorage.getItem("userId")),
      centreId: 101,
      schemeName: formData.schemeName.trim(),
      centreName: formData.centreName.trim(),
      principal: Number(formData.principal),
      tenure: Number(formData.tenure),
      roi: Number(formData.roi),
      recoveryFrequency: formData.recoveryFrequency || "monthly",
      collectorName: formData.collectorName.trim(),
      loanRoiType: formData.loanRoiType || "reducing",
      loanDisbursalMode: formData.loanDisbursalMode || "cash",
      loanAppliedDate: formData.loanAppliedDate,
      collectionLandmark: formData.collectionLandmark,
      loanPurpose: formData.loanPurpose,
      generateEmi: Boolean(formData.generateEmi), // ✅ ensure boolean
      createdBy: Number(localStorage.getItem("userId")) || 1,
      members: clients.map(c => ({
        memberId: c.userId,
        loanAmount: Number(c.loanAmount),
        isLeader: c.isLeader || false,
      })),
    };

    try {
      const res = await axios.post(
        `https://payyug.in/api/group-loan/apply-loan-group`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      toast.success("✅ Group Loan Applied Successfully!");
      console.log("API Response:", res.data);

      // reset form
      setFormData({
        schemeName: "",
        centreName: "",
        principal: "",
        tenure: "",
        roi: "",
        recoveryFrequency: "monthly",
        collectorName: "",
        loanRoiType: "flat",
        loanDisbursalMode: "cash",
        loanAppliedDate: new Date().toISOString().split("T")[0],
        collectionLandmark: "",
        loanPurpose: "",
        generateEmi: false, // default false
        createdBy: localStorage.getItem("userId") || 1,
      });
      setClients([{ userId: "", loanAmount: "", isLeader: false }]);
      setSelectedGroup("");
    } catch (error) {
      console.error("❌ Error applying group loan:", error);
      toast.error(error.response?.data?.message || "Failed to apply loan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="group-loan-container">
      <h2 className="form-title">Apply Loan</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Select Group</label>
          <select value={selectedGroup} onChange={(e) => setSelectedGroup(e.target.value)} required>
            <option value="">-- Select Group --</option>
            {groups.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
          </select>
        </div>

        <div className="form-grid-two-column">


         <div className="form-group">
           <label>Scheme Name</label>
            <input
              type="text"
              name="schemeName"
              value={formData.schemeName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Centre Name</label>
            <input
              type="text"
              name="centreName"
              value={formData.centreName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Principal Amount</label>
            <input
              type="number"
              name="principal"
              value={formData.principal}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Tenure (Months)</label>
            <input
              type="number"
              name="tenure"
              value={formData.tenure}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>ROI Annual (%)</label>
            <input
              type="number"
              name="roi"
              value={formData.roi}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Recovery Frequency</label>
            <select
              name="recoveryFrequency"
              value={formData.recoveryFrequency}
              onChange={handleChange}
            >
              <option value="monthly">Monthly</option>
              <option value="quarterly">Quarterly</option>
              <option value="yearly">Yearly</option>
              <option value="weekly">Weekly</option>
              <option value="biweekly">Bi-Weekly</option>
              <option value="halfyearly">Half-Yearly</option>
              <option value="delay">Delay</option>
            </select>
          </div>

          <div className="form-group">
            <label>Collector Name</label>
            <input
              type="text"
              name="collectorName"
              value={formData.collectorName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>ROI Type</label>
            <select
              name="loanRoiType"
              value={formData.loanRoiType}
              onChange={handleChange}
            >
              <option value="flat">Flat</option>
              <option value="reducing">Reducing</option>
            </select>
          </div>

          <div className="form-group">
            <label>Disbursal Mode</label>
            <select
              name="loanDisbursalMode"
              value={formData.loanDisbursalMode}
              onChange={handleChange}
            >
              <option value="cash">Cash</option>
              <option value="bank">Bank</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label>Applied Date</label>
            <input
              type="date"
              name="loanAppliedDate"
              value={formData.loanAppliedDate}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Collection Landmark</label>
            <input
              type="text"
              name="collectionLandmark"
              value={formData.collectionLandmark}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Loan Purpose</label>
            <input
              type="text"
              name="loanPurpose"
              value={formData.loanPurpose}
              onChange={handleChange}
            />
          </div>



          
        </div>

        <h3 className="section-title">Group Members</h3>
        {clients.map((client, index) => (
          <div className="form-row" key={index}>
            <select
              name="userId"
              value={client.userId}
              onChange={(e) => handleClientChange(index, e)}
              required
            >
              <option value="">-- Select Customer --</option>
              {customers.map(cust => <option key={cust.userId} value={cust.userId}>{cust.userId} - {cust.fullName}</option>)}
            </select>

            <input
              type="number"
              name="loanAmount"
              placeholder="Loan Amount"
              value={client.loanAmount}
              onChange={(e) => handleClientChange(index, e)}
              required
            />

            <label>
              <input
                type="checkbox"
                name="isLeader"
                checked={client.isLeader || false}
                onChange={(e) => handleClientChange(index, e)}
              />
              Leader
            </label>
          </div>
        ))}

        <button type="button" onClick={addClientRow} className="btn add">➕ Add Member</button>

        <div className="form-actions">
          <button type="submit" className="btn submit" disabled={loading}>
            {loading ? "Submitting..." : "🚀 Apply Loan"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default GroupLoanScheme;